<template>
    <ModalDialogContainer ref="modalContainer" v-model:display="displayStatus" @keydown="escapeToClose">
        <div class="modal-dialog modal-md" role="document" @click="stopPropagationEvent">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">{{ $t("Send Transcription/Summary") }}</div>
                    <button type="button" class="btn-close" :title="$t('Close')" @click="close"></button>
                </div>
                <div class="modal-body">
                    <label>{{ $t("You are about to leave the current room and stop the recording.") }}</label>
                    <label>{{ $t("Would you like to receive a full transcription or an AI-generated summary of the conversation to your email?") }}</label>
                    <br><br>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="leave-transcription-input" v-model="transcription">
                        <label for="leave-transcription-input">{{ $t("Full Transcription") }}</label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="leave-summary" v-model="summary">
                        <label for="leave-summary">{{ $t("AI-generated Summary") }}</label>
                    </div>
                    <div v-if="error" class="error-message">{{ error }}</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="send">
                        <i v-if="summary || transcription" class="fa-regular fa-paper-plane"></i>
                        <i v-else class="fa-solid fa-phone-slash"></i>
                        {{ !summary && !transcription ? $t("Leave without sending") : $t("Leave and send") }}
                    </button>
                    <button type="button" class="btn btn-cancel" @click="close">{{ $t("Cancel") }}</button>
                </div>
            </div>
        </div>
    </ModalDialogContainer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVModel } from "@/utils/v-model";

export default defineComponent({
    name: "LeaveAndSendRecordingModal",
    emits: ["update:display", "confirm", "deny"],
    props: {
        display: Boolean,
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    data() {
        return {
            error: "", 

            transcription: false,
            summary: false,
        };
    },
    methods: {
        close: function () {
            this.displayStatus = false;
            this.$emit("deny");
            this.reset();
        },

        send: function() {
            this.$emit("confirm", this.transcription, this.summary);
            this.displayStatus = false;
            this.reset();
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.close();
            }
        },

        stopPropagationEvent: function (e) {
            e.stopPropagation();
        },
        reset: function () {
            this.error = "";
        },
    },
    mounted: function () {
        if (this.display) {
            this.$autoFocus();
        }
    },
    watch: {
        display: function () {
            if (this.display) {
                this.$autoFocus();
            }
        },
    },
});
</script>

<style scoped>
/* @import "@/style/modals/delete-version.css"; */
</style>
